<template><div><h1 id="freie-artikelnummern-liste" tabindex="-1"><a class="header-anchor" href="#freie-artikelnummern-liste"><span>Freie Artikelnummern-Liste</span></a></h1>
<p>Freie Artikelnummern-Liste — listet freie Nummerbereiche aus</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste mit allen nicht benutzten Artikelnummern, die im angegebenen Range [von Artikelnummer - bis Artikelnummer] liegen. Dient der Neuerfassung von Artikeln bei alphanumerischer Nummernvergabe.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Freie Artikelnummern-Liste</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>von Artikelnummer</dt>
<dd>von Artikelnummer, leer = alle, inklusive</dd>
<dt>bis</dt>
<dd>bis Artikelnummer, leer = alle, inklusive</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>von</td>
<td>erste freie Nummer in zusammenhängendem Bereich bzw. einzige Nummer</td>
</tr>
<tr>
<td>bis</td>
<td>letzte freie Nummer in zusammenhängendem Bereich</td>
</tr>
<tr>
<td>freie Nummern</td>
<td>Anzahl Nummern im zusammenhängenden Bereich</td>
</tr>
<tr>
<td>Zeilen</td>
<td>Totale pro Nummernbereich und insgesamt</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                                19.02.1999 11:28:08 leh  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                          Freie Artikelnummern-Liste</span>
<span class="line">                   von Artikelnummer: 0001.00 bis: 9999.00</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                Freie Nummern</span>
<span class="line">von      bis      Anzahl freie Nummern</span>
<span class="line">-------- -------- --------------------</span>
<span class="line">10       11                          2</span>
<span class="line">40       42                          3</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line">984      986                         3</span>
<span class="line">                                  ----</span>
<span class="line">                                   172 TOTAL</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line">9992                                 1</span>
<span class="line">9995                                 1</span>
<span class="line">                                  ----</span>
<span class="line">                                   722 TOTAL</span>
<span class="line"></span>
<span class="line">                                  ----</span>
<span class="line">                                  5761 TOTAL</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Die Artikelnummern 40 bis 42 sind frei, was drei freien Nummern entspricht. Im Tausenderblock 0 bis 1000 sind insgesamt 172 Nummern frei, im gesamten Auswertungsbereich sind 5'761 Nummern frei.</p>
</div></template>


